module.exports = __webpack_public_path__ + "img/callout-dots-left.a0f9c0f1.png";